var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "52px",
    viewBox: "0 0 52 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 27") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GFL-Marketing",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GFL---Landing-Page",
    transform: "translate(-1396, -7396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(-0, 7227)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(1397, 170)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#C6A566",
    strokeWidth: 2,
    fill: "#1A1A1A",
    cx: 25,
    cy: 25,
    r: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1855384,37 L27.1855384,26.2 L30.4644316,26.2 L31,21.4 L27.1855384,21.4 L27.1855384,19.0624 C27.1855384,17.8264 27.2171116,16.6 28.9442608,16.6 L30.6936268,16.6 L30.6936268,13.168 C30.6936268,13.1164 29.1909964,13 27.6708244,13 C24.4960048,13 22.5080884,14.9884 22.5080884,18.64 L22.5080884,21.4 L19,21.4 L19,26.2 L22.5080884,26.2 L22.5080884,37 L27.1855384,37 Z",
    id: "facebook-[#176]",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.2af2470ab13d4d9a71cfaa41fe887ef1.svg";
export { ForwardRef as ReactComponent };